import React from "react"
import { makeStyles, Theme, Box, Link } from "@material-ui/core"
import { InputLabel } from "../@citydna/common/InputLabel"
import SimpleMDEEditor from "react-simplemde-editor"
import "easymde/dist/easymde.min.css"
import { SchemaField } from "../featuer-layer-settings/schema"
import { Controller, useFormContext } from "react-hook-form"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles((theme: Theme) => ({
  markdownEditor: {
    "& .editor-toolbar": {
      borderColor:
        theme.palette.type === "dark"
          ? theme.palette.grey[400]
          : theme.palette.grey[200],
      borderBottomColor: "transparent",
    },
    "& .cm-header": {
      fontWeight: "normal",
    },
    "& .cm-link": {
      color: theme.palette.secondary.main,
    },
  },
  inputLabel: {
    ...theme.typography.button,
    textTransform: "none",
    marginBottom: theme.spacing(0.5),
    color:
      theme.palette.type === "dark"
        ? theme.palette.grey[50]
        : theme.palette.grey[800],
  },
}))

interface DNAMarkdownFieldProps {
  field: SchemaField
}

export const MarkdownField: React.FC<DNAMarkdownFieldProps> = ({ field }) => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  /** Hook up to form */
  const { control } = useFormContext()

  return (
    <Box>
      <Box display="flex">
        <InputLabel htmlFor={field.name}>
          {field.alias}
          {!field.required && " (optional)"}
        </InputLabel>
        <Box ml="auto">
          <Link
            color="secondary"
            href="https://www.markdownguide.org/cheat-sheet/"
            target="_blank"
          >
            Uses markdown
          </Link>
        </Box>
      </Box>
      <Controller
        name={field.name || ""}
        control={control}
        defaultValue=""
        render={({ value, onChange }) => (
          <SimpleMDEEditor
            value={value}
            onChange={onChange}
            className={classes.markdownEditor}
          />
        )}
      />
    </Box>
  )
}
